import React from 'react'
import Footer from "../../aboutus/aboutfooter/Aboutfooter"

function Askquestionfooter() {
    return (
        <div>
            <Footer />
        </div>
    )
}


export default Askquestionfooter;